var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sider-avatar" },
    [
      _c("AppAvatar", {
        attrs: {
          name: _vm.userInfo.nickName,
          width: 68,
          avatar: _vm.userInfo.avatar,
          "no-name": true,
        },
      }),
      _c("div", { staticClass: "block name" }, [
        _vm._v(_vm._s(_vm.userInfo.nickName)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }